module.exports = __webpack_public_path__ + "static/img/c5x2.fa851406.png";